export const DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES = 'DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES,';
export const DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES = 'DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES';
export const CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES = 'CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES';
export const DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES = 'DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES';
export const SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES = 'SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES';
export const DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES = 'DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES';
export const DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES = 'DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES';
export const CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES = 'CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES';



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/constants.js